import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const RosterForm = ({ rosterId, initialData, onSuccess }) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [rosterName, setRosterName] = useState('');
  const [rosterIn, setRosterIn] = useState('');
  const [rosterOut, setRosterOut] = useState('');
  const [totalHours, setTotalHours] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // ✅ Pre-fill if editing
  useEffect(() => {
    if (initialData && initialData.shift_roster) {
      setRosterName(initialData.shift_roster);
      setRosterIn(initialData.shift_in || '');
      setRosterOut(initialData.shift_out || '');
      setTotalHours(initialData.total_hours || '');
    }
  }, [initialData]);

  // ✅ Calculate difference whenever In/Out changes
  useEffect(() => {
    if (rosterIn && rosterOut) {
      const inTime = new Date(`1970-01-01T${rosterIn}:00`);
      const outTime = new Date(`1970-01-01T${rosterOut}:00`);

      let diffMs = outTime - inTime;
      if (diffMs < 0) {
        // If out < in, assume next day
        diffMs += 24 * 60 * 60 * 1000;
      }

      const hours = String(Math.floor(diffMs / (1000 * 60 * 60))).padStart(2, '0');
      const minutes = String(Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
      const seconds = String(Math.floor((diffMs % (1000 * 60)) / 1000)).padStart(2, '0');

      setTotalHours(`${hours}:${minutes}:${seconds}`);
    }
  }, [rosterIn, rosterOut]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!rosterName.trim() || !rosterIn || !rosterOut) {
      setError('All fields are required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      let url = '';
      let method = 'POST';
      let body = {
        shift_roster: rosterName,
        shift_in: rosterIn + ":00",
        shift_out: rosterOut + ":00",
        total_hours: totalHours,
      };

      if (rosterId) {
        url = `${baseUrl}/updateShiftRosterById/${rosterId}`;
      } else {
        url = `${baseUrl}/createShiftRoster`;
      }

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (data.status) {
        alert(rosterId ? 'Roster updated successfully' : 'Roster created successfully');
        if (onSuccess) onSuccess();
        navigate('/roster');
      } else {
        setError(data.message || 'Failed to save roster');
      }
    } catch (err) {
      setError('Error connecting to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="general-info-form" onSubmit={handleSubmit}>
      <h2 className="section-title">{rosterId ? 'Edit Roster' : 'Add Roster'}</h2>
      <div className="form-grid">
        {/* Roster Name */}
        <div className="form-floating">
          <input
            type="text"
            className="form-control"
            id="rosterName"
            placeholder=" "
            autoComplete="off"
            value={rosterName}
            onChange={(e) => setRosterName(e.target.value)}
            disabled={loading}
          />
          <label htmlFor="rosterName">Roster Name</label>
        </div>

        <div className="form-floating">
          <input
            type={rosterIn ? "time" : "text"}   // 👈 Switch between text & time
            className="form-control"
            id="rosterIn"
            placeholder=" "
            value={rosterIn}
            onFocus={(e) => e.target.type = "time"}  // 👈 Change to time picker when focused
            onBlur={(e) => { if (!rosterIn) e.target.type = "text"; }} // 👈 Reset if empty
            onChange={(e) => setRosterIn(e.target.value)}
            disabled={loading}
          />
          <label htmlFor="rosterIn">Shift In</label>
        </div>

        {/* Shift Out */}
        <div className="form-floating">
          <input
            type={rosterOut ? "time" : "text"}
            className="form-control"
            id="rosterOut"
            placeholder=" "
            value={rosterOut}
            onFocus={(e) => e.target.type = "time"}
            onBlur={(e) => { if (!rosterOut) e.target.type = "text"; }}
            onChange={(e) => setRosterOut(e.target.value)}
            disabled={loading}
          />
          <label htmlFor="rosterOut">Shift Out</label>
        </div>

        {/* Total Hours (readonly) */}
        <div className="form-floating">
          <input
            type="text"
            className="form-control"
            id="totalHours"
            placeholder=" "
            value={totalHours}
            readOnly
          />
          <label htmlFor="totalHours">Total Hours</label>
        </div>
      </div>

      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
      <button
        type="submit"
        className="btn btn-primary"
        style={{ marginTop: '15px' }}
        disabled={loading}
      >
        {loading ? 'Saving...' : 'Save'}
      </button>
    </form>
  );
};

export default RosterForm;





// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import './GeneralInfoForm.css';

// const RosterForm = ({ rosterId, initialData, onSuccess }) => {
//     const baseUrl = process.env.REACT_APP_BASE_URL;
//   const [rosterName, setRosterName] = useState('');
//   const [rosterIn, setRosterIn] = useState('');
//   const [rosterOut, setRosterOut] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const navigate = useNavigate();

//   // ✅ Fill form if initialData is provided (edit mode)
//   useEffect(() => {
//     if (initialData && initialData.shift_roster) {
//       setRosterName(initialData.shift_roster);
//     }
//   }, [initialData]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!rosterName.trim()) {
//       setError('Roster name is required');
//       return;
//     }

//     setLoading(true);
//     setError('');

//     try {
//       let url = '';
//       let method = 'POST';
//       let body = {};

//       if (rosterId) {
//         // ✅ Edit mode
//         url = `${baseUrl}/updateShiftRosterById/${rosterId}`;
//         body = { shift_roster: rosterName };
//       } else {
//         // ✅ Create mode
//         url = `${baseUrl}/createShiftRoster`;
//         body = { shift_roster: rosterName };
//       }

//       const response = await fetch(url, {
//         method,
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(body),
//       });

//       const data = await response.json();

//       if (data.status) {
//         alert(rosterId ? 'Roster updated successfully' : 'Roster created successfully');
//         if (onSuccess) onSuccess();
//         navigate('/roster');
//       } else {
//         setError(data.message || `Failed to ${rosterId ? 'update' : 'create'} PYAGROUP`);
//       }
//     } catch (err) {
//       setError('Error connecting to server');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <form className="general-info-form" onSubmit={handleSubmit}>
//       <h2 className="section-title">{rosterId ? 'Edit Roster' : 'Add Roster'}</h2>
//       <div className="form-grid">
//         <div className="form-floating">
//           <input
//             type="text"
//             className="form-control"
//             id="rosterName"
//             placeholder=" "
//             autoComplete="off"
//             value={rosterName}
//             onChange={(e) => setRosterName(e.target.value)}
//             disabled={loading}
//           />
//           <label htmlFor="rosterName">Roster Name</label>
//         </div>
//         <div className="form-floating">
//           <label htmlFor="rosterIn" className="form-label">Roster In</label>
//           <input
//             type="time"
//             className="form-control"
//             id="rosterIn"
//             value={rosterIn}
//             onChange={(e) => setRosterIn(e.target.value)}
//             disabled={loading}
//           />
//         </div>

//         <div className="form-floating">
//           <label htmlFor="rosterOut" className="form-label">Roster Out</label>
//           <input
//             type="time"
//             className="form-control"
//             id="rosterOut"
//             value={rosterOut}
//             onChange={(e) => setRosterOut(e.target.value)}
//             disabled={loading}
//           />
//         </div>
//       </div>
//       {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
//       <button
//         type="submit"
//         className="btn btn-primary"
//         style={{ marginTop: '15px' }}
//         disabled={loading}
//       >
//         {loading ? 'Saving...' : 'Save'}
//       </button>
//     </form>
//   );
// };

// export default RosterForm;